import { TermsType } from '@pages/UserGuide/Detail/constants/general';

export const STORAGE_KEY = {
  // convention: use '@' as prefix
  LAST_TERMS_READ: (type: TermsType) => `@lastTermsRead.${type}`,
  LAST_AUTO_ASSIGN_READ: () => '@lastAutoAssignRead',
};

const useLocalStorage = () => {
  const setStorage = (key: string, value: unknown) => {
    localStorage.setItem(key, JSON.stringify(value));
  };

  const getStorage = (key: string) => {
    const data = localStorage.getItem(key);
    try {
      if (data) return JSON.parse(data);

      return data;
    } catch {
      return data;
    }
  };

  const removeStorage = (key: string) => {
    localStorage.removeItem(key);
  };

  return { setStorage, getStorage, removeStorage };
};

export default useLocalStorage;
